interface ExternalSource {
  id: string
  primaryUrl: string
  fallbackUrls: string[]
  pathPattern?: (path: string) => string
}

const SOURCES: Record<string, ExternalSource> = {
  'britannica-soccer': {
    id: 'britannica-soccer',
    primaryUrl: 'https://www.britannica.com/sports/football-soccer',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Association_football']
  },
  'wikipedia-search': {
    id: 'wikipedia-search',
    primaryUrl: 'https://en.wikipedia.org/',
    fallbackUrls: ['https://www.wikidata.org/'],
    pathPattern: (path) =>
      `https://en.wikipedia.org/wiki/Special:Search?search=${encodeURIComponent(path)}`
  },
  'pokeapi-species': {
    id: 'pokeapi-species',
    primaryUrl: 'https://pokeapi.co/',
    fallbackUrls: ['https://pokeapi.co/docs/v2#pokemon-species'],
    pathPattern: (path) => `https://pokeapi.co/api/v2/pokemon-species/${encodeURIComponent(path)}/`
  },
  'scryfall-revised': {
    id: 'scryfall-revised',
    primaryUrl: 'https://scryfall.com/sets/3ed',
    fallbackUrls: ['https://mtg.fandom.com/wiki/Revised_Edition']
  },
  'scryfall-search': {
    id: 'scryfall-search',
    primaryUrl: 'https://scryfall.com/',
    fallbackUrls: ['https://gatherer.wizards.com/'],
    pathPattern: (path) =>
      `https://scryfall.com/search?as=grid&order=name&q=${encodeURIComponent(`!"${path}"`)}`
  },
  unesco: {
    id: 'unesco',
    primaryUrl: 'https://whc.unesco.org/en/list/',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Lists_of_World_Heritage_Sites']
  },
  'wikipedia-castles': {
    id: 'wikipedia-castles',
    primaryUrl: 'https://en.wikipedia.org/wiki/List_of_castles',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Fortification']
  },
  'britannica-inventions': {
    id: 'britannica-inventions',
    primaryUrl: 'https://www.britannica.com/technology/history-of-technology',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Timeline_of_historic_inventions']
  },
  pubchem: {
    id: 'pubchem',
    primaryUrl: 'https://pubchem.ncbi.nlm.nih.gov/',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Chemical_compound']
  },
  nasa: {
    id: 'nasa',
    primaryUrl: 'https://science.nasa.gov/',
    fallbackUrls: ['https://solarsystem.nasa.gov/']
  },
  wikivoyage: {
    id: 'wikivoyage',
    primaryUrl: 'https://www.wikivoyage.org/',
    fallbackUrls: ['https://www.lonelyplanet.com/']
  },
  'wikivoyage-search': {
    id: 'wikivoyage-search',
    primaryUrl: 'https://www.wikivoyage.org/',
    fallbackUrls: ['https://en.wikipedia.org/wiki/List_of_tourist_attractions_worldwide'],
    pathPattern: (path) =>
      `https://en.wikivoyage.org/wiki/Special:Search?search=${encodeURIComponent(path)}`
  },
  'met-collection': {
    id: 'met-collection',
    primaryUrl: 'https://www.metmuseum.org/art/collection',
    fallbackUrls: ['https://www.nga.gov/collection.html']
  },
  'history-encyclopedia': {
    id: 'history-encyclopedia',
    primaryUrl: 'https://www.britannica.com/topic/history',
    fallbackUrls: ['https://www.history.com/']
  },
  archdaily: {
    id: 'archdaily',
    primaryUrl: 'https://www.archdaily.com/',
    fallbackUrls: ['https://en.wikipedia.org/wiki/Architecture']
  },
  kew: {
    id: 'kew',
    primaryUrl: 'https://powo.science.kew.org/',
    fallbackUrls: ['https://www.gbif.org/']
  },
  noaa: {
    id: 'noaa',
    primaryUrl: 'https://oceanservice.noaa.gov/',
    fallbackUrls: ['https://www.marinespecies.org/']
  }
}

export function getSourceLink(sourceId: string, path?: string): string | null {
  const source = SOURCES[sourceId]
  if (!source) return null
  if (path && source.pathPattern) return source.pathPattern(path)
  return source.primaryUrl
}

export function getSourceFallbacks(sourceId: string): string[] {
  return SOURCES[sourceId]?.fallbackUrls ?? []
}

export function getAllSourceRecords(): ExternalSource[] {
  return Object.values(SOURCES)
}
